import { motion } from "framer-motion";

// Sanftes Einblenden beim Scrollen – ruhig und unaufgeregt (Design-Vorgabe).
export function Reveal({ children, delay = 0, y = 30, className = "", as = "div", ...rest }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ type: "spring", stiffness: 100, damping: 20, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

// Kleine Kapitel-Nummer im Editorial-Stil.
export function ChapterLabel({ index, label, color = "text-brand-green" }) {
  return (
    <Reveal className="flex flex-wrap items-center gap-3 md:gap-4">
      <span className={`font-accent text-3xl md:text-4xl ${color}`}>
        {String(index).padStart(2, "0")}
      </span>
      <span className="hidden sm:block h-px w-12 bg-ink/20" />
      <span className="text-xs sm:text-sm md:text-base font-semibold uppercase tracking-[0.15em] sm:tracking-[0.2em] text-ink-muted">
        {label}
      </span>
    </Reveal>
  );
}
